import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../../ui/authorizedUiElement";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";
import { StateService } from "@uirouter/angularjs";

export const vsServiceName = "roleDetailTabsService";
export const vsProviderName = `${vsServiceName}Provider`;

export class RoleDetailTabsServiceProvider extends AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig> {
  $get: any = [
    UserProfileName,
    "$state",
    (userProfile: UserProfile, $state: StateService) => {
      return this.defaultServiceFactory(userProfile, $state);
    },
  ];
  basePath: string = "main.users.roles.detail";
}
